<div class="card card-w-title">
  <h1>Gestione fascicoli</h1>
  <div class="grid">
    <div class="col-3 col-offset-9" style="padding-right:0;">
      <button class="addButton" pButton type="button" icon="fa fa-plus" label="Aggiungi Fascicolo"
        title="Aggiungi fascicolo" (click)="openModalAddFolder()"></button>
    </div>
  </div>

  <app-gestione-posizioni-table [treeChild]="tree$ | async" (downloadAggregazioneXml)="downloadAggregazioneXml($event)"
    (moveNode)="moveNode($event)" (modifyNode)="modifyNode($event)">
  </app-gestione-posizioni-table>
</div>

<app-muovi-posizione-dialog [stopBelowLevels]="disableFromLevel" [isMoveDialogActive]="isMoveDialogActive"
  (closeDialog)="closeMoveNode()" (save)="saveMoveNode($event)">
</app-muovi-posizione-dialog>

<app-add-position [visible]="addDialogVisible" [nodeToModify]="nodeToModify" [typeOfEvent]="typeOfEvent"
  (isCompleted)="addedPosition()" (closed)="closeModalAddFolder()"></app-add-position>
